import React, { createContext, useContext, useState } from 'react'
import { DOCUMENT_TYPE } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { ReceptorScanType } from '../../Evidence/evidence.constants'

type AutomatedScanContextType = {
  selectedScan: ReceptorScanType
  setSelectedScan: (scanType: ReceptorScanType) => void
  initialReceptorModelId?: string
  setInitialReceptorModelId: (modelId: string | undefined) => void
  initialFolderScanReceptorId?: string
  setInitialFolderScanReceptorId: (receptorId: string | undefined) => void
  documentType: DOCUMENT_TYPE
  setDocumentType: (type: DOCUMENT_TYPE) => void
}

const AutomatedScanContext = createContext<AutomatedScanContextType>({
  selectedScan: ReceptorScanType.EVIDENCE_RECEPTOR,
  setSelectedScan: () => undefined,
  setInitialReceptorModelId: () => undefined,
  setInitialFolderScanReceptorId: () => undefined,
  documentType: DOCUMENT_TYPE.EVIDENCE,
  setDocumentType: () => undefined,
})

export const useAutomatedScanContext = (): AutomatedScanContextType =>
  useContext(AutomatedScanContext)

export const AutomatedScanContextProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [selectedScan, setSelectedScan] = useState<ReceptorScanType>(
    ReceptorScanType.EVIDENCE_RECEPTOR,
  )
  const [initialReceptorModelId, setInitialReceptorModelId] = useState<
    string | undefined
  >(undefined)
  const [initialFolderScanReceptorId, setInitialFolderScanReceptorId] =
    useState<string | undefined>(undefined)
  const [documentType, setDocumentType] = useState<DOCUMENT_TYPE>(
    DOCUMENT_TYPE.EVIDENCE,
  )

  return (
    <AutomatedScanContext.Provider
      value={{
        selectedScan,
        setSelectedScan,
        initialReceptorModelId,
        setInitialReceptorModelId,
        initialFolderScanReceptorId,
        setInitialFolderScanReceptorId,
        documentType,
        setDocumentType,
      }}
    >
      {children}
    </AutomatedScanContext.Provider>
  )
}
